import React from "react";
import BasicLayout from "../components/layouts/BasicLayout";
import HeroBanner from "../components/HeroBanner";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { useTranslation } from "gatsby-plugin-react-i18next";
import ImageDetailCard from "../components/ImageDetailCard";
import LinkColorTile from "../components/LinkColorTile";

import { GatsbySeo } from "gatsby-plugin-next-seo";

export default function Industries({ data }) {
  const { t } = useTranslation();

  return (
    <BasicLayout>
      <GatsbySeo
        title={t("Beschaffungslösungen für Industrie und Handel | Line Up")}
        description={t(
          "Sie möchten eigene Produkte herstellen lassen: Nutzen Sie unsere langjährige Beschaffungsexpertise für Industrie und Handel."
        )}
        metaTags={[
          {
            name: "keywords",
            content: t(
              "beschaffungsmärkte, eigenes produkt herstellen lassen, strategische beschaffung, eigene produkte produzieren lassen, hersteller für eigenes produkt finden, produktbeschaffung, produktentwicklung dienstleistung, accessoires, anlagenbau, armaturen, asiatisches netzwerk, bauindustrie, bekleidungsindustrie, beschaffungsprozess, beschaffungslösungen, bestandteile, blechverarbeitung, branchenspezifisch, branchenübergreifend, brausen, chinesische werkzeugmarke, diamantwerkzeuge, distributionskonzepte, e-commerce-strategien, effizienz, eigenfertigung, eigenmarkenprodukte, elektrowerkzeuge, erfahrung, expertenwissen, fulfillment, funktionelle textilien, galvanik, global sourcing, glasprodukte, glaszubehör, groß- und online-handel, großhandel, handel, handwerkzeuge, holzverarbeitung, individuelle verpackung, industrie, kundenspezifisch, kundenzufriedenheit, kunststoffverarbeitung, label, leistung, liefergeschwindigkeit, lieferkette, lieferzuverlässigkeit, logistiklösungen, logistikprozesse, machinebau, maßgeschneiderte lösungen, materialauswahl, online-handel, optimierte supply chain, private label, produktentwicklung, produktfertigung, produktionsprozesse, qualitätskontrollen, qualitätsstandards, sanitaerbedarf, sanitaerprodukte, skalierbare lösungen, sortiment, spezialisierung, stanzprodukte, supply chain, textilaccessoires, textilien, tolsen, trennscheiben, vertriebsprozesse, werkzeug, werkzeugbau, werkzeugtaschen, wirtschaftlichkeit, zuverlässigkeit"
            ),
          },
        ]}
        canonical={"https://www.lineup.de" + t("/branchen/")}
        languageAlternates={[
          {
            hrefLang: "x-default",
            href: "https://www.lineup.de/branchen/",
          },
          {
            hrefLang: "de",
            href: "https://www.lineup.de/branchen/",
          },
          {
            hrefLang: "en",
            href: "https://www.lineup.de/en/industries/",
          },
        ]}
        openGraph={{
          url: "https://www.lineup.de" + t("/branchen/"),
          title: t("Beschaffungslösungen für Industrie und Handel | Line Up"),
          description: t(
            "Sie möchten eigene Produkte herstellen lassen: Nutzen Sie unsere langjährige Beschaffungsexpertise für Industrie und Handel."
          ),
          images: [
            {
              url: "https://www.lineup.de/assets/img/Line_Up-og.jpg",
              width: 800,
              height: 600,
              alt: t("Beschaffungslösungen für Industrie und Handel | Line Up"),
            },
          ],
        }}
        twitter={{
          handle: "@lineup_handels_gmbh",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <HeroBanner
        title={t("Produkte herstellen lassen")}
        subtitle={t("Spezialist für Industrie und Handel")}
        description={t(
          "Unser langjähriges Know-how setzen wir für viele Branchen ein. Sehen Sie selbst, welche Erfolge wir mit unseren Kunden erreicht haben."
        )}
        buttonText={t("Mehr erfahren")}
        backgroundImage={getImage(data.banner)}
        linkTo={"#services"}
      />
      <section id="services" className="section-bg">
        <div className="sectionTitle">
          <h2>{t("Branchen")}</h2>
          <p>
            {t(
              "Ein kleiner Einblick in unseren Kundenkreis und unsere Success-Stories"
            )}
          </p>
          <h3>{t("Für Ihre Branche die passenden Produkte")}</h3>
          <p>
            {t(
              "Wer Produkte herstellen lassen will, muss sich auf einen Partner verlassen, der sich in vielen Branchen auskennt. Wir sind Ihr Spezialist für Industrie und Handel und durch unser langjähriges Know-how zusätzlich in der Lage, auch andere Bereiche abzudecken. Was dabei gilt und sich für Sie auszahlt: Dass hohe Qualität, Kosteneffizienz und zuverlässige Liefertreue stets im Fokus stehen."
            )}
          </p>
        </div>
        <div className="container services-container" data-aos="fade-up">
          <div className="row">
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Sanitärprodukte für den Großhandel")}
                description={t(
                  "Ob Accessoires, Armaturen, Brausen oder Zubehörprodukte - für führende europäische Großhändler aus der Sanitärbranche fertigt Line Up individuelle Eigenmarkenprodukte. Dabei setzen wir Wünsche mitsamt Verpackung und Labeling nach individuellen Vorgaben um."
                )}
                image={getImage(data.sanitary)}
                linkTo={t("/branche/sanitaer_grosshandel")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Produkte für die Bauindustrie")}
                description={t(
                  "In der Baubranche setzen wir schon lange kundenspezifische Produkte um, während wir gleichzeitig die komplette Supply Chain optimieren. So kümmern wir uns über die Fertigung und Produktion hinaus um alles, was nötig ist. Damit Ihre Produkte für die Bauindustrie optimal umgesetzt werden. Und weil bei allen Industrieprozessen die Wirtschaftlichkeit entscheidend ist."
                )}
                image={getImage(data.construction)}
                linkTo={t("/branche/bauindustrie")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Individuell gefertigte Komponenten")}
                description={t(
                  "Ob Stanzprodukte, Werkzeugbau, Blechverarbeitung, Kunststoffverarbeitung, Galvanik oder Holzverarbeitung – Line Up beherrscht alle gängigen Methoden, um Ihre individuell gefertigten Komponenten in bester Qualität zu produzieren. Denn erst die unterschiedlichen Materialien und Bestandteile machen Ihre Produkte einzigartig und perfekt."
                )}
                image={getImage(data.components)}
                linkTo={t("/branche/individuelle_komponenten")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Werkzeug fertigen lassen")}
                description={t(
                  "Ob Handwerkzeuge, Trennscheiben, Diamantwerkzeuge, Elektrowerkzeuge, Werkzeugtaschen oder weiteres Zubehör – mit unserer Expertise ermöglichen wir die Fertigung Ihres gesamten Produktsortiments. Darüber hinaus führen wir das gesamte Sortiment der chinesischen Werkzeugmarke TOLSEN."
                )}
                image={getImage(data.tools)}
                linkTo={t("/branche/werkzeug_fertigen")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Glasprodukte für Eigenmarken")}
                description={t(
                  "Wir fertigen Glastüren, Vordächer und weitere Glasprodukte für Ihre Eigenmarke. Und damit Sie auch komplette Sets und Produkte vertreiben können, gehören auch Beschläge und Glaszubehörprodukte zu unserem Repertoire. Dabei setzen wir individuelle Verpackungs- und Distributionskonzepte für Sie um."
                )}
                image={getImage(data.glass)}
                linkTo={t("/branche/glasprodukte_eigenmarke")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
            <div
              className="col-md-4 d-flex align-items-stretch"
              data-aos="fade-up"
            >
              <ImageDetailCard
                title={t("Bekleidung und Textilien herstellen lassen")}
                description={t(
                  "Unsere Wurzeln liegen in der Bekleidungsindustrie. Denn als Diplom-Ingenieure gründeten Mustafa und Helga Silanoglu Line Up mit der Umsetzung textiler Lösungen und Produkte. Und auch heute noch fertigen wir Ihre Stoffe, Textilaccessoires und Bekleidungsstücke mit allen Funktionen und Finessen in bester Qualität."
                )}
                image={getImage(data.textile)}
                linkTo={t("/branche/textil_und_bekleidung")}
                buttonText={t("Mehr erfahren")}
              />
            </div>
          </div>
        </div>
        {/* <div className="container" data-aos="fade-up">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-8 col-md-6">
              <h2>
                {t("Line Up: branchenübergreifende Beschaffungslösungen")}
              </h2>
              <p>
                {t(
                  "Streben Sie nach kosteneffizienter, qualitativ hochwertiger und zuverlässiger Produktfertigung, ohne sich mit Einkaufsrisiken oder kulturellen und kommunikativen Barrieren auseinandersetzen zu müssen? Verlassen Sie sich auf Line Up. Wir übernehmen den vollständigen Beschaffungsprozess in enger Abstimmung mit Ihnen, um eine nahtlose und risikofreie Beschaffung zu gewährleisten. Die persönliche Beratung ist dem Line Up Team besonders wichtig. Unser umfangreiches und exzellentes Netzwerk, insbesondere in Asien, ermöglicht es uns, im global sourcing maßgeschneiderte Produkte sowohl für kleinere Bestellmengen   als auch in Serienproduktion anzubieten. Mit der Bemusterung von Line Up profitieren Sie von individueller, effizienter Materialauswahl für ästhetisch und funktionell überzeugende Produkte. Zudem führen wir professionelle Qualitätskontrollen durch und bieten herausragende Logistiklösungen und Importabwicklungen an."
                )}
                <br />
                <br />
                {t(
                  "Mit Line Up haben Sie Zugang zu einer Vielfalt an Fertigungsverfahren, die exakt auf Ihre Bedürfnisse zugeschnitten sind. Line Up bedient ein breites Spektrum an Branchen. Ob es um Private Label-Produktion im Lifestyle-Segment geht, um Komponentenfertigung im Anlagenbau und Maschinenbau, oder im Groß- und Online-Handel um Sanitärbedarf – wir bieten maßgeschneiderte Lösungen, die exakt auf Ihre spezifischen Anforderungen und die Besonderheiten Ihrer Branche zugeschnitten sind. Vertrauen Sie auf Line Up, um Ihren individuellen Beschaffungsprozess in die Realität umzusetzen."
                )}
              </p>
              <h3>{t("Handel & Eigenfertigung")}</h3>
              <p>
                {t(
                  "Line Up steht für Qualität und Zuverlässigkeit in der Branche des Handels und der Eigenfertigung. Unser Fokus liegt darauf, maßgeschneiderte Beschaffungslösungen dank eigener Produktionsanlagen anzubieten, die speziell auf Ihre Bedürfnisse und Anforderungen zugeschnitten sind. Von der Produktentwicklung bis hin zur Lieferung bieten wir einen umfassenden Service, der höchste Standards in Qualität und Effizienz gewährleistet. Unser Ziel ist es, Ihren Beschaffungsprozess Wirklichkeit werden zu lassen, unterstützt durch unser Expertenwissen und unsere innovativen Fertigungstechniken. Gemeinsam mit unseren hochwertigen Herstellern fertigen wir Ihr maßgeschneidertes Produkt unter Eigenfertigung. "
                )}
              </p>
              <h3>{t("Großhandel")}</h3>
              <p>
                {t(
                  "Der Großhandel, definiert als der Vertrieb von Waren in großen Mengen an Wiederverkäufer oder professionelle Endverbraucher, profitiert enorm von Line Ups Expertise in der Optimierung von Logistik- und Vertriebsprozessen, um Effizienz und Kundenzufriedenheit zu steigern. Im Großhandelsegment versteht Line Up die Bedeutung von Skalierbarkeit und Zuverlässigkeit. Wir bieten maßgeschneiderte Beschaffungsprozesse für Großhändler, die eine reibungslose Beschaffung von qualitativ hochwertigen Produkten benötigen. Unser erfahrenes Team gewährleistet eine optimale Kundenbetreuung, schnelle Lieferzeiten und eine nahtlose Abwicklung, um Ihre Handelsprozesse zu unterstützen. Mit Line Up als Partner können Sie sich auf einen stetigen Warenfluss und exzellenten Kundenservice verlassen."
                )}
              </p>
              <h3>{t("Komponenten")}</h3>
              <p>
                {t(
                  "Line Up ist spezialisiert auf die Bereitstellung von hochwertigen Komponenten für eine Vielzahl von Anwendungen. Spezialisiert hat sich Line Up im Maschinenbau und Anlagenbau. Wir verstehen die technischen und qualitativen Anforderungen unserer Kunden und bieten gefertigte Komponenten, die sich nahtlos in Ihre Produktionsprozesse einfügen. Ob es um Standardteile oder maßgefertigte Lösungen geht, unser Team arbeitet eng mit Ihnen zusammen, um die beste Passform für Ihre spezifischen Bedürfnisse zu finden. Verlassen Sie sich auf Line Up für Komponenten, die in puncto Qualität, Zuverlässigkeit und Leistung keine Kompromisse eingehen."
                )}
              </p>
              <h3>{t("Private Label")}</h3>
              <p>
                {t(
                  "Für Marken, die unter Private Label agieren, bietet Line Up eine einzigartige Plattform zur Realisierung Ihrer Markenvisionen. Wir unterstützen Sie dabei, Produkte unter einer Eigenmarke zu entwickeln, die nicht nur qualitativ hochwertig sind, sondern auch Ihre Markenidentität widerspiegeln. Von der Produktidee bis zur Lieferung des Endproduktes arbeiten wir eng mit Ihnen zusammen, um sicherzustellen, dass das Produkt Ihren Erwartungen entspricht. Unsere Expertise in der Beschaffung und Produktion ermöglicht es uns, Ihren Private Label-Anforderungen gerecht zu werden und Ihren Markenwert durch qualitativ hochwertige Produkte zu steigern."
                )}
              </p>
              <h3>{t("Online-Handel")}</h3>
              <p>
                {t(
                  "Im dynamischen Umfeld der Branche des Online-Handels versteht Line Up die Notwendigkeit schneller, effizienter und skalierbarer Lösungen. Der Einkauf und Verkauf über das Internet nimmt immer mehr Bedeutung an. Wir bieten individuelle Unterstützung, um Ihre E-Commerce-Strategien zu optimieren. Unser Team hilft Ihnen dabei, Ihre Produkte schnell und zuverlässig zu liefern, wobei wir stets auf eine optimale Balance zwischen Kosten und Liefergeschwindigkeit achten. Fulfillment im Online-Handel ist ein entscheidender Faktor für den Erfolg eines E-Commerce-Geschäfts, und Line Up bietet maßgeschneiderte Lösungen, um die Lagerung, Verpackung, Einlagerung und den Versand von Produkten effizient und kundenorientiert zu gestalten. Mit Line Up können Sie sich darauf verlassen, dass Ihre Online-Präsenz durch reibungslose Logistikprozesse und exzellente Produktqualität gestärkt wird."
                )}
              </p>
            </div>
          </div>
        </div> */}
      </section>
      <section id="services" className="services-block">
        <div className="sectionTitle">
          <h2>{t("Leistungen")}</h2>
          <h3>{t("Full-Service mit Fokus Fernost")}</h3>
        </div>
        <div className="container services-container" data-aos="fade-up">
          <div className="row">
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/beratung")}
                title={t("Beratung")}
                icon={getImage(data.consultation)}
                iconHover={getImage(data.consultationHover)}
              />
            </div>
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/bemusterung/")}
                title={t("Bemusterung")}
                icon={getImage(data.sampling)}
                iconHover={getImage(data.samplingHover)}
              />
            </div>
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/serienfertigung/")}
                title={t("Serienfertigung")}
                icon={getImage(data.seriesProduction)}
                iconHover={getImage(data.seriesProductionHover)}
              />
            </div>
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/qualitaetskontrolle/")}
                title={t("Qualitätskontrolle")}
                icon={getImage(data.qualityControl)}
                iconHover={getImage(data.qualityControlHover)}
              />
            </div>
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/importabwicklung/")}
                title={t("Importabwicklung")}
                icon={getImage(data.import)}
                iconHover={getImage(data.importHover)}
              />
            </div>
            <div className="col-md-4 col-lg-2 d-flex align-items-stretch mb-5 mb-lg-0">
              <LinkColorTile
                link={t("/leistung/logistik/")}
                title={t("Logistik")}
                icon={getImage(data.logistic)}
                iconHover={getImage(data.logisticHover)}
              />
            </div>
          </div>
        </div>
      </section>
    </BasicLayout>
  );
}

export const query = graphql`
  query HomeQuery($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    banner: file(
      relativePath: { eq: "heroBanner/IndustriesMainBackground.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    consultation: file(relativePath: { eq: "icons/black-discussion.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    consultationHover: file(
      relativePath: { eq: "icons/white-discussion.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    sampling: file(relativePath: { eq: "icons/black-3d-cube.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    samplingHover: file(relativePath: { eq: "icons/white-3d-cube.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    seriesProduction: file(relativePath: { eq: "icons/black-setting.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    seriesProductionHover: file(
      relativePath: { eq: "icons/white-setting.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    qualityControl: file(relativePath: { eq: "icons/black-evaluation.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    qualityControlHover: file(
      relativePath: { eq: "icons/white-evaluation.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    import: file(relativePath: { eq: "icons/black-data-transfer.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    importHover: file(relativePath: { eq: "icons/white-data-transfer.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    logistic: file(relativePath: { eq: "icons/black-container-ship.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    logisticHover: file(
      relativePath: { eq: "icons/white-container-ship.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    sanitary: file(relativePath: { eq: "industries/sanitaer-teaser.jpg" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }

    construction: file(
      relativePath: { eq: "industries/bauindustrie-teaser.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    components: file(
      relativePath: { eq: "industries/komponenten-teaser.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    tools: file(relativePath: { eq: "industries/werkzeug-teaser.jpg" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    glass: file(relativePath: { eq: "industries/glasprodukte-teaser.jpg" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
    textile: file(
      relativePath: { eq: "industries/textil_und_bekleidung-teaser.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [PNG, WEBP])
      }
    }
  }
`;
